import { IResponse } from './request/response'

const buildUrl = (idCalendar: number, lastSync: Date) => {
  const date = Math.floor(lastSync.getTime() / 1000)

  return `/api/v2/misc/changeinfo/last_sync_date/${date}/id_calendar/${idCalendar}`
}

export default function(api: GlobalFetch) {
  return async function(idCalendar: number, lastSync: Date = new Date()) {
    const response = await api.fetch(buildUrl(idCalendar, lastSync))
    const responseBody: IResponse = await response.json()

    if (false === 'modified' in responseBody.items) {
      throw new Error('Response should receive at least one item!')
    }

    return responseBody.items.modified
  }
}
